// extracted by mini-css-extract-plugin
export default {"disabled_screen":"DisabledScreen_disabled_screen__9EO3h"};